import { render, staticRenderFns } from "./ArticleModulePopup.vue?vue&type=template&id=47a2002f&scoped=true&"
import script from "./ArticleModulePopup.vue?vue&type=script&lang=ts&"
export * from "./ArticleModulePopup.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleModulePopup.vue?vue&type=style&index=0&id=47a2002f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a2002f",
  null
  
)

export default component.exports